module.exports = {
	"next": "次へ",
	"skip": "Cozy 作成へジャンプ",
	"cancel": "キャンセル",
	"back": "戻る",
	"sign up": "登録",
	"add email": "メールアカウントを追加",
	"welcome": "入りたい!",
	"confirm": "確認",
	"step preset": "設定",
	"step import": "データのインポート",
	"step email settings": "メールの構成",
	"preset email": "メール",
	"preset email tip": "あなたがパスワードを紛失した場合に連絡するために使用されます。",
	"preset name": "名前",
	"preset name tip": "人とファイルを共有したり、イベントに招待するときに表示されます。",
	"preset password": "パスワード",
	"preset password tip": "8 文字以上の強いパスワードが必要です (特殊文字を推奨)。",
	"preset timezone": "タイムゾーン",
	"preset timezone tip": "カレンダーのイベントを正しく表示するために、タイムゾーンが必要です。",
	"preset opt-in help": "製品を改善するために、Cozy が私の使用状況を使用することを許可します。",
	"preset opt-out newsletter": "ベータ Cozy ニュースレターを購読します (強く推奨)。",
	"import from google": "私の Google アカウントからデータをインポート",
	"import google account": "Google から Gmail アカウントを同期して、カレンダー、連絡先、写真をインポートします",
	"import google account tip": "Cozy が Google でホストされているデータにアクセスできるようにするため、Google アカウントにログインする必要があります",
	"leave google title": "Cozy にデータをフィード",
	"leave google help me": "何をすべきかわかりません。助けてください!",
	"leave google sign in content": "Google アカウントにサインインして、Cozy がアクセスすることを承認してください。複雑な文字列を取得します。クリップボードにコピーしてください。",
	"leave google sign in": "Google にサインイン",
	"leave google code content": "次に、ポップアップからこのフィールドにコードをコピー＆貼り付けします:",
	"leave google code": "Google コード",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Google のサーバーに保存されたデータで何をしたいかを選択してください:",
	"leave google choice sync gmail": "GMail - Cozy からメールにアクセス",
	"leave google choice contacts": "Google の連絡先を 1 回インポート",
	"leave google choice calendar": "Google カレンダーを 1 回インポート",
	"leave google choice photos": "Google フォトを 1 回インポート",
	"leave google confirm": "データのインポート",
	"import error": "データをインポートしようとしたときにエラーが発生しました。専用アプリから後でもう一度試してください。",
	"login welcome": "%{username} さん、ようこそ",
	"login enter your password": "Cozy にアクセスするパスワードを入力してください",
	"login password": "パスワード",
	"login otp": "認証コード",
	"login submit": "サインイン",
	"login auth success": "正常に認証しました。始めましょう!",
	"login recover": "パスワードをお忘れですか? 説明をメールで送信してください",
	"login recover again": "受信しませんでしたか? 再度送信します",
	"login recover sent title": "メールを送信しました",
	"login recover sent message": "メールを確認してください。パスワードをリセットするための説明に従ってください。",
	"login recover error title": "メールの送信時にエラー",
	"login recover error message": "パスワード回復メッセージの送信中にエラー。MTA (メールサーバー) が実行しているか確認してください、またはサーバー管理者に連絡してください",
	"login wrong password title": "資格情報が間違っています",
	"login wrong password message": "入力した資格情報が間違っています。もう一度試してください",
	"reset welcome": "パスワードをリセット",
	"reset enter your password": "%{username} さん、アクセスをリセットするため、新しいパスワードを入力してください",
	"reset password": "パスワード",
	"reset submit": "パスワードをリセット",
	"reset auth success": "パスワードを正常にリセットしました",
	"reset wrong password title": "パスワードをリセットできません",
	"reset wrong password message": "入力したパスワードが間違っているか、リセットトークンの有効期限が切れています",
	"setup title": "Cozy をセットアップしています…",
	"setup message": "データが格納される、あなた自身のパーソナルクラウドに近づきました。",
	"setup on mobile title": "お使いの Android デバイスとデータを同期しましょう!",
	"setup on mobile message": "Google Play で私たちのモバイルアプリをチェックしてください:",
	"welcome title": "あなたの個人データをコントロールできるようになりました。おめでとうございます!",
	"welcome message": "あなた自身のパーソナルクラウド上にデータを保存することができるようになりました。ほとんどのクラウドサービスとは対照的に、Cozy ではデータマイニングは行われません。"
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/ja.json
 ** module id = 33
 ** module chunks = 1
 **/